import Rx from 'rxjs';
import { push } from 'react-router-redux';
import { combineEpics } from 'redux-observable';
import { fromJS } from 'immutable';
import { change } from 'redux-form/immutable';

import * as constAction from 'root/actionConstants';
import * as abonadosActions from 'modules/abonados/action';
import * as generalActions from 'modules/general/action';
import * as errorActions from 'modules/error/action';
import { request } from 'core/generalFunctions';
import { dias } from 'core/constants';

const { ajax } = Rx.Observable;

export const getEpic = (action$, store) =>
  action$
    .ofType(constAction.ABONADOS_GET)
    .debounceTime(1000)
    .switchMap((action) =>
      ajax(request(action))
        .map((result) => abonadosActions.setLista(result.response))
        .catch((err) => errorActions.request(err, action))
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide())),
    );

export const getAbonadosActivosEpic = (action$, store) =>
  action$.ofType(constAction.ABONADOS_GET_ACTIVOS).switchMap((action) =>
    ajax(request(action))
      .map((result) => abonadosActions.setState({ abonadosActivos: result.response }))
      .catch((err) => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const getByIdEpic = (action$, store) =>
  action$.ofType(constAction.ABONADOS_GET_BY_ID).switchMap((action) =>
    ajax(request(action))
      .mergeMap(({ response }) => {
        if (!response) return Rx.Observable.empty();
        const abonadoReservasAutomaticas = response._reservasAutomaticas,
          abonadoLastAbonos = response._abonos;
        delete response._abonos;
        delete response._reservasAutomaticas;

        return [abonadosActions.setState({ abonado: response, abonadoLastAbonos }), abonadosActions.setReservasAutomaticasState(abonadoReservasAutomaticas)];
      })
      .catch((err) => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const setEpic = (action$, store) =>
  action$
    .ofType(constAction.ABONADOS_SET)
    .throttleTime(5000)
    .switchMap((action) => {
      const { id, isUser, usuarioExtension } = action;
      return !isUser
        ? ajax(request(action))
            .mergeMap(({ response }) => {
              return id == 'new'
                ? [abonadosActions.setExtension(response.id, usuarioExtension, isUser), push(`/dashboard/abonados/add/${response.id}/${isUser}`), generalActions.snackbar_show('Abonado creado.')]
                : [abonadosActions.setExtension(id, usuarioExtension, isUser), push('/dashboard/abonados')];
            })
            .catch((err) => errorActions.request(err, action))
            .startWith(generalActions.loadingbar_show())
            .finally(() => store.dispatch(generalActions.loadingbar_hide()))
        : Rx.Observable.merge(Rx.Observable.of(abonadosActions.setExtension(id, usuarioExtension, isUser)), Rx.Observable.of(push('/dashboard/abonados')));
    });

export const getLastAbonoEpic = (action$, store) =>
  action$.ofType(constAction.ABONADOS_GET_LAST_ABONO).switchMap((action) =>
    ajax(request(action))
      .map(({ response }) => abonadosActions.setState({ abonadoLastAbonos: response }))
      .catch((err) => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const setExtensionEpic = (action$, store) =>
  action$.ofType(constAction.ABONADOS_SET_EXTENSION).switchMap((action) =>
    ajax(request(action))
      .mapTo(generalActions.snackbar_show('Datos guardados.'))
      .catch((err) => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const setAbonoEpic = (action$, store) =>
  action$
    .ofType(constAction.ABONADOS_SET_ABONO)
    .throttleTime(5000)
    .switchMap((action) =>
      ajax(request(action))
        .mapTo(abonadosActions.getLastAbono(action.payload.usuarioId || action.payload.abonadoId, action.isUser))
        .concat(Rx.Observable.of(generalActions.snackbar_show('Abono guardado')))
        .catch((err) => errorActions.request(err, action))
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide())),
    );

export const deleteAbonoEpic = (action$, store) =>
  action$.ofType(constAction.ABONADOS_DELETE_ABONO).switchMap((action) =>
    ajax(request(action))
      .mapTo(abonadosActions.deleteState({ key: 'abonadoLastAbonos', id: action.payload.abonoId }))
      .concat(Rx.Observable.of(generalActions.snackbar_show('Abono eliminado')))
      .catch((err) => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const setReservasAutomaticasEpic = (action$, store) =>
  action$.ofType(constAction.ABONADOS_RESERVAS_AUTOMATICAS_SET).switchMap((action) =>
    ajax(request(action))
      .mergeMap(() => {
        const { abonadoId, usuarioId } = action.payload;
        return [abonadosActions.getById(abonadoId || usuarioId, usuarioId ? true : false), generalActions.snackbar_show('Reservas automaticas guardadas')];
      })
      .catch((err) => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const getReservasAutomaticasEpic = (action$, store) =>
  action$.ofType(constAction.ABONADOS_RESERVAS_AUTOMATICAS_GET).switchMap((action) =>
    ajax(request(action))
      .map(({ response }) => abonadosActions.setState({ abonadoReservasAutomaticas: response }))
      .catch((err) => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const delReservasAutomaticasEpic = (action$, store) =>
  action$.ofType(constAction.ABONADOS_DELETE_RA).switchMap((action) =>
    ajax(request(action))
      .mergeMap(() => [abonadosActions.delStateRA(action.path), generalActions.snackbar_show('Reserva automática borrada.')])
      .catch((err) => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const getParadasTrayectoEpic = (action$, store) =>
  action$.ofType(constAction.ABONADOS_GET_TRAYECTOS_PARADAS).mergeMap((action) =>
    ajax(request(action))
      .map(({ response }) => abonadosActions.setState({ trayectoSeleccionado: response }))
      .catch((err) => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const getReservasEpic = (action$, store) =>
  action$.ofType(constAction.ABONADOS_GET_RESERVAS).switchMap((action) =>
    ajax(request(action))
      .map(({ response }) => abonadosActions.setState({ reservasUsuario: response }))
      .catch((err) => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const getByDocEpic = (action$, store) =>
  action$.ofType(constAction.ABONADOS_FIND_BYID).mergeMap((action) =>
    ajax(request(action))
      .flatMap(({ response }) => {
        const { formName } = action;
        if (!response) return Rx.Observable.merge([change(formName, 'documento', action.payload.documento), abonadosActions.setState({ blockForm: false })]);
        if (response.usuarioId || response.abonadoId) return Rx.Observable.merge([abonadosActions.setState({ blockForm: true }), generalActions.snackbar_show('El documento ya se encuentra en uso.')]);
        return Rx.Observable.merge([
          change(formName, 'nombre', response.nombre),
          change(formName, 'apellido', response.apellido),
          change(formName, 'telefono', response.telefono),
          abonadosActions.setState({ blockForm: false }),
        ]);
      })
      .catch((err) => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const deleteEpic = (action$, store) =>
  action$
    .ofType(constAction.ABONADOS_DELETE)
    .throttleTime(1000)
    .switchMap((action) =>
      ajax(request(action))
        .mergeMap(() => [abonadosActions.setState({ lista: [] }), push('/dashboard/abonados')])
        .startWith(generalActions.loadingbar_show())
        .catch((err) => errorActions.request(err, action))
        .finally(() => store.dispatch(generalActions.loadingbar_hide())),
    );

export default combineEpics(
  setEpic,
  getEpic,
  getByIdEpic,
  getLastAbonoEpic,
  setAbonoEpic,
  deleteAbonoEpic,
  setReservasAutomaticasEpic,
  getReservasAutomaticasEpic,
  getAbonadosActivosEpic,
  getParadasTrayectoEpic,
  setExtensionEpic,
  delReservasAutomaticasEpic,
  getReservasEpic,
  getByDocEpic,
  deleteEpic,
);



// WEBPACK FOOTER //
// src/modules/abonados/epics.js